import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from '../../../services/actions';
import styles from './AlerteAffichage.module.scss';

const AlerteAffichage = () => {
  const dispatch = useDispatch();
  const alertesListe = useSelector((state) => state.alrt.alertesListe);

  // Filtrer seulement les alertes de connexion (mot de passe, email invalide, email non trouvé)
  const alertesConnexion = alertesListe.filter(
    (alerte) =>
      alerte.corps === 'Email incorrect ou mot de passe incorrect.' ||
      alerte.corps === 'Email incorrect ou mot de passe incorrect.'
  );

  const handleDismiss = (index) => {
    // Trouver l'index réel dans la liste complète
    const alerteToRemove = alertesConnexion[index];
    const realIndex = alertesListe.findIndex(
      (alerte) => alerte === alerteToRemove
    );
    dispatch(actions.supprimer(realIndex));
  };

  if (!alertesConnexion || alertesConnexion.length === 0) {
    return null;
  }

  return (
    <div className={styles.alerteContainer}>
      {alertesConnexion.map((alerte, index) => (
        <div
          key={index}
          className={`${styles.alerte} ${
            styles[alerte.typeAlerte] || styles.info
          }`}
        >
          <div className={styles.alerteContent}>
            <div className={styles.alerteTitre}>{alerte.titre}</div>
            {alerte.corps && (
              <div className={styles.alerteCorps}>{alerte.corps}</div>
            )}
          </div>
          <button
            className={styles.alerteClose}
            onClick={() => handleDismiss(index)}
            aria-label="Fermer l'alerte"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default AlerteAffichage;
